import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import Marquee from "@/components/landing/Marquee";
import AboutJoselle from "@/components/landing/AboutJoselle";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import NewsletterSection from "@/components/landing/NewsletterSection";
import PropertyListings from "@/components/landing/PropertyListings";
import RecentlySold from "@/components/landing/RecentlySold";
import ManifestoChapters from "@/components/landing/ManifestoChapters";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const delays = [150, 700, 1600];
    const timers = delays.map((d) =>
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: "auto" });
      }, d)
    );
    return () => timers.forEach(clearTimeout);
  }, [hash]);

  return (
    <div data-testid="landing-page" className="bg-[#0D0B0E] text-slate-100 min-h-screen">
      <Navbar />
      <HeroSection />
      <Marquee />
      <PropertyListings />
      <RecentlySold />
      <AboutJoselle />
      <TestimonialsSection />
      <NewsletterSection />
      <ManifestoChapters />
      <ContactSection />
      <Footer />
    </div>
  );
}
